import baseFont from '../baseFont/index.js';

// Shared Chart.js legend-label font so every chart legend matches the
// line-graph (RangeChart) look the client preferred: 16px, medium weight.
export default () => ({
  size: 16,
  family: baseFont(),
  weight: 500,
});
